import React, { useRef, useState } from "react";
import {
  Box,
  MenuItem,
  Popper,
  ClickAwayListener,
  Paper,
  Typography,
} from "@mui/material";
import { FixedSizeList } from "react-window";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const PageDropdown = ({ currentPage, totalPages, handlePageChange ,insideModal = false}) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const toggleDropdown = () => setOpen((prev) => !prev);
  const closeDropdown = () => setOpen(false);
  const visibleCount = Math.min(totalPages, 5);
  const itemHeight = 36;

  const Row = ({ index, style }) => (
    <MenuItem
      key={index}
      value={index + 1}
      style={style}
      onClick={() => {
        handlePageChange(null, index + 1);
        closeDropdown();
      }}
    >
      {index + 1}
    </MenuItem>
  );

  return (
    <ClickAwayListener onClickAway={closeDropdown}>
      <Box>
        <Box
          ref={anchorRef}
          onClick={toggleDropdown}
          className="glass-dropdown"
          sx={{
            height: "36px",
            fontSize: "14px",
            padding: "4px 12px",
            border: "1px solid rgba(0,0,0,0.2)",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            userSelect: "none",
            backgroundColor: "rgba(255,255,255,0.3)",
            backdropFilter: "blur(8px)",
          }}
        >
          <Typography variant="body2" sx={{ fontSize: "14px" }}>
            {currentPage}
          </Typography>
          <ArrowDropDownIcon
            sx={{ ml: 0.5, fontSize: "20px", pointerEvents: "none" }}
          />
        </Box>

        <Popper
          open={open}
          anchorEl={anchorRef.current}
          placement="top-start"
          disablePortal={false}
          modifiers={[
            {
              name: "offset",
              options: {
                offset: [0, 4],
              },
            },
          ]}
          style={{ zIndex: insideModal ? 1400 : 1300 }} 
        >
          <Paper
            elevation={3}
            sx={{
              maxHeight: 200,
              width: 60,
              overflow: "auto",
              mt: 1,
              borderRadius: 1,
              fontSize: "14px",
              // zIndex: 1300,
              zIndex: insideModal ? 1400 : 1300,
              backdropFilter: "blur(8px)",
              backgroundColor: "rgba(255,255,255,0.95)",
            }}
            className="glass-dropdown"
          >
            <FixedSizeList
              // height={200}
              height={visibleCount * itemHeight}
              width={60}
              // itemSize={36}
               itemSize={itemHeight}
              itemCount={totalPages}
            >
              {Row}
            </FixedSizeList>
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  );
};

export default PageDropdown;
